import styled from 'styled-components'

const Code = styled('code')`
  color: ${props => props.theme.colors.text.one};
  font-size: 13px;
  line-height: 17px;
  white-space: normal;
`

export default Code
